export default __webpack_public_path__ + "static/media/mainbg.794c5d32.mp4";